import { useEffect } from 'react';

interface JsonLdItem {
  '@context'?: string;
  '@type': string;
  [key: string]: unknown;
}

export function useJsonLd(data: JsonLdItem | JsonLdItem[] | null) {
  useEffect(() => {
    if (!data) return;
    const items = Array.isArray(data) ? data : [data];
    const scriptElements: HTMLScriptElement[] = [];

    items.forEach((item) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        ...item,
      });
      document.head.appendChild(script);
      scriptElements.push(script);
    });

    return () => {
      scriptElements.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, [data]);
}